<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <AnswerPopup
          :show="showAnswerPopup"
          @finish="onfinish"
          @close="closeAnswerPopup"
          :SuggestionsId="SuggestionsId"
          :SuggestionsContent="SuggestionsContent"
        ></AnswerPopup>
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          v-has-permission="permission767"
          :columns="[
            { title: $t('FullName') },
            { title: $t('Email') },
            { title: $t('MobileNumber') },
            { title: $t('Title') },
            { title: $t('Answer'), sort: 'Answer' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 22%">{{ row.fullName }}</td>
            <td style="width: 22%">
              {{ row.emailAddress }}
            </td>
            <td style="width: 11%">
              {{ row.mobileNumber }}
            </td>
            <td style="width: 11%">
              {{ row.header }}
            </td>
            <td style="width: 11%">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                class="bordered-btn"
                v-has-permission="permission768"
                @click.prevent="onShowAnswerPopup(row)"
                >{{ $t("Answer") }}</vs-button
              >
            </td>
            <td style="width: 11%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AnswerPopup from "./AnswerPopup.vue";

export default {
  name: "",
  components: {
    AnswerPopup,
    DataGrid,
  },
  data() {
    return {
      permission767: "GetAllSuggestionsWithOutAnswer",
      permission768: "AssignAnswer",
      showAnswerPopup: false,
      SuggestionsContent: "",
      SuggestionsId: 0,
      gridDataSource: {
        type: "app",
        service: "CMS/api/SuggestionsQuery/without-answer",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    onShowAnswerPopup(row) {
      this.showAnswerPopup = true;
      this.SuggestionsId = row.id;
      this.SuggestionsContent = row.content;
    },
    closeAnswerPopup() {
      this.showAnswerPopup = false;
    },
    onfinish() {
      this.closeAnswerPopup();
    },
  },
};
</script>
